import { render, staticRenderFns } from "./ContasWhatsapp.vue?vue&type=template&id=c9f0bb8c&"
import script from "./ContasWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ContasWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ContasWhatsapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports